import { matchPath } from 'react-router-dom';

import type { Module } from 'router/types';

import { getFeature } from 'stores/features-list-store';
import { injectParamsInUrl } from 'globals/helpers';
import { routeTriggerMapping } from './constants';

export const showHotjarSurvey = (route: Module) => {
  if (!window.hj) {
    return;
  }

  const hotjarFeature = getFeature('ribbon');
  if (!hotjarFeature?.value) {
    return;
  }

  if (!route.url) {
    return;
  }

  const pageUrl = injectParamsInUrl(route.url, route.params);

  for (const mappingPath in routeTriggerMapping) {
    const [routePath, routeQuery] = mappingPath.split('?');
    const [pageUrlPath, pageUrlQuery] = pageUrl.split('?');

    const isPathMatched = matchPath(
      { path: routePath || '', caseSensitive: false, end: true },
      pageUrlPath || '',
    );

    if (isPathMatched) {
      if (!routeQuery || compareQueryParams(routeQuery, pageUrlQuery)) {
        window.hj('event', routeTriggerMapping[mappingPath]);
        break;
      }
    }
  }
};

function compareQueryParams(routeQuery, pageQuery) {
  if (!routeQuery) return true;
  if (!pageQuery) return false;

  const routeParams = new URLSearchParams(routeQuery);
  const pageParams = new URLSearchParams(pageQuery);

  for (const [key, value] of routeParams) {
    if (pageParams.get(key) !== value) {
      return false;
    }
  }

  return true;
}

export const initiliaseHotjar = () => {
  const scriptSource = window.WAM.ENV.cdnEnabled
    ? `${window.WAM.ENV.cdnUrl}/app/vendor/hotjar.js`
    : '/app/vendor/hotjar.js';

  const hotjarScript = document.createElement('script');
  hotjarScript.type = 'text/javascript';
  hotjarScript.src = scriptSource;

  document.head.appendChild(hotjarScript);
};

type HotjarUserAttributes = {
  locale: string;
};
export const setHotjarUserAttributes = ({ locale }: HotjarUserAttributes) => {
  if (!window.hj) {
    return;
  }

  if (locale) {
    const languageCode = locale.split('_')[0];

    // We send only English (en_*) locales to Hotjar
    if (languageCode === 'en') {
      window.hj('identify', null, {
        locale,
        language_code: languageCode,
      });
    } else {
      window.hj('identify', null, {
        locale: null,
        language_code: null,
      });
    }
  }
};
